(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_product-card-gallery"] && !Shopify.designMode) return;
  try {
    window.ironlineMobAdd = window.ironlineMobAdd || async function(btn) {
    if (btn.dataset.loading === 'true') return;
    const variantId = btn.dataset.variantId;
    if (!variantId) return;

    btn.dataset.loading = 'true';
    const originalHTML = btn.innerHTML;

    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      });

      if (!res.ok) throw new Error('Cart add failed');

      // Show success checkmark
      btn.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>';
      btn.classList.add('success');

      // Update cart count bubble in header if it exists
      fetch('/cart.js')
        .then(r => r.json())
        .then(cart => {
          document.querySelectorAll('[data-cart-count], .cart-count, .cart-item-count').forEach(el => {
            el.textContent = cart.item_count;
          });
          // Dispatch the theme's cart update event so the drawer updates
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        });

      setTimeout(() => {
        btn.innerHTML = originalHTML;
        btn.classList.remove('success');
        btn.dataset.loading = 'false';
      }, 1800);
    } catch (e) {
      btn.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>';
      btn.classList.add('error');
      setTimeout(() => {
        btn.innerHTML = originalHTML;
        btn.classList.remove('error');
        btn.dataset.loading = 'false';
      }, 1800);
    }
  };
  } catch(e) { console.error(e); }
})();

})();
